import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { GetEvaluationQuestions } from "../../../actions/teacherQueries";
import {
  PostEvaluationQuestions,
  UpdateEvaluationQuestion,
  DeleteEvaluationQuestion,
} from "../../../actions/teacherMutations";

export default function useAPLEvaluationQuestions(activePeriodId) {
  const [studentQuestions, setStudentQuestions] = useState([]);
  const [supervisorQuestions, setSupervisorQuestions] = useState([]);
  const [questionsToDelete, setQuestionsToDelete] = useState([]);

  const createEvaluationQuestions = useMutation(PostEvaluationQuestions);
  const updateEvaluationQuestion = useMutation(UpdateEvaluationQuestion);
  const deleteEvaluationQuestions = useMutation(DeleteEvaluationQuestion);

  const evaluationQuestionsData = GetEvaluationQuestions(activePeriodId);

  useEffect(() => {
    if (
      !evaluationQuestionsData.isLoading &&
      evaluationQuestionsData.data !== null
    ) {
      const tempStudentQuestions = [];
      const tempSupervisorQuestions = [];

      evaluationQuestionsData.data.forEach((question) => {
        switch (question.forUserType) {
          case 4:
            tempSupervisorQuestions.push(question);
            break;
          case 1:
            tempStudentQuestions.push(question);
            break;
          default:
            break;
        }
      });

      setStudentQuestions(tempStudentQuestions);
      setSupervisorQuestions(tempSupervisorQuestions);
    }
  }, [evaluationQuestionsData.isLoading, evaluationQuestionsData.data]);

  const handleSaveEvaluationQuestions = (periodId, studentQs, supervisorQs) => {
    const newQuestions = [];
    const questionsToUpdate = [];

    studentQs.forEach((q, index) => {
      const question = {
        periodId: periodId,
        question: q.question,
        responseRange: q.responseRange,
        sortOrder: index + 1,
        forUserType: "Student",
      };
      if (q.id) {
        questionsToUpdate.push({
          id: q.id,
          question: question,
        });
      } else {
        newQuestions.push(question);
      }
    });

    let tempQuestion = studentQs.filter((question) => question.id);
    setStudentQuestions(tempQuestion);

    supervisorQs.forEach((q, index) => {
      const question = {
        periodId: periodId,
        question: q.question,
        responseRange: q.responseRange,
        sortOrder: index + 1,
        forUserType: "AplSupervisor",
      };
      if (q.id) {
        questionsToUpdate.push({
          id: q.id,
          question: question,
        });
      } else {
        newQuestions.push(question);
      }
    });

    createEvaluationQuestions.mutate(newQuestions, {
      onSuccess: (data) => {
        const tempStudentQuestions = [...studentQs];
        const tempSupervisorQuestions = [...supervisorQs];
        data.forEach((question) => {
          switch (question.forUserType) {
            case 4:
              tempSupervisorQuestions.push(question);
              break;
            case 1:
              tempStudentQuestions.push(question);
              break;
            default:
              break;
          }
        });

        let tempQuestion = tempStudentQuestions.filter(
          (question) => question.id
        );
        setStudentQuestions(tempQuestion);

        tempQuestion = tempSupervisorQuestions.filter(
          (question) => question.id
        );
        setSupervisorQuestions(tempQuestion);
      },
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });

    questionsToUpdate.forEach((question) => {
      updateEvaluationQuestion.mutate(question, {
        onError: (data) => {
          toast.warn(data.response.data);
        },
      });
    });

    questionsToDelete.forEach((question) => {
      deleteEvaluationQuestions.mutate(question.id, {
        onError: (data) => {
          toast.warn(data.response.data);
        },
      });
    });

    if (questionsToDelete.length > 0) {
      setQuestionsToDelete([]);
    }
  };

  return {
    studentQuestions,
    setStudentQuestions,
    supervisorQuestions,
    setSupervisorQuestions,
    questionsToDelete,
    setQuestionsToDelete,
    handleSaveEvaluationQuestions,
    evaluationQuestionsData,
  };
}
